var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","color":"#9a9a9a"}},[_vm._v(" 当前版本: "+_vm._s(_vm.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }